import { useEffect, useRef, useState } from "react"
import { CONTAINER_SIZES } from "@/constants/ui"
import { useContainerQuery } from "@/hooks/use-container-query"
import { DetailedEventActor } from "@/types/event-actor"

import { eventActorToAmplitudeProperties } from "@/lib/analytics/amplitude-properties"
import { sendAnalyticsEvent } from "@/lib/analytics/amplitude-utils"
import { useAppDispatch } from "@/lib/storage/hooks"
import { EventActorDetail } from "./event-actor-detail"
import { StickyBottomBar } from "./sticky-bottom-bar"

export interface EventActorMainProps {
  eventActor: DetailedEventActor
}

export function EventActorMain({ eventActor }: EventActorMainProps) {
  const dispatch = useAppDispatch()
  const init = useRef(false)
  const containerRef = useRef<HTMLDivElement>(null)
  const [actionsPortal, setActionsPortal] = useState<HTMLDivElement | null>(
    null
  )

  useEffect(() => {
    if (!init.current) {
      init.current = true

      sendAnalyticsEvent({
        name: "ViewEventActorDetailStandalone",
        properties: {
          event_actor: eventActorToAmplitudeProperties(eventActor),
          urlPath: eventActor.canonical_url,
        },
      })
    }
  }, [dispatch, eventActor])

  const isLargeUI = useContainerQuery(containerRef, CONTAINER_SIZES.xl)

  return (
    <>
      <div
        ref={containerRef}
        className="@container/detail px-(--container-pad)"
      >
        {isLargeUI !== undefined && (
          <EventActorDetail
            eventActor={eventActor}
            key={eventActor.entity_ref}
            actionsPortal={actionsPortal}
            isLargeUI={isLargeUI}
            contentRef={containerRef}
          />
        )}
      </div>
      <StickyBottomBar ref={setActionsPortal} />
    </>
  )
}
